export default "__VITE_ASSET__BBov$m1A__"